module.exports = __webpack_public_path__ + "static/media/CC20-MB210-12.b4c2a00d.png";